import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tv-sharp",
  "use": "icon-tv-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-tv-sharp\"><title>Tv</title><path d=\"M488 384H24a8 8 0 01-8-8V88a8 8 0 018-8h464a8 8 0 018 8v288a8 8 0 01-8 8z\" /><rect x=\"112\" y=\"400\" width=\"288\" height=\"32\" rx=\"4\" ry=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol